import React from 'react';
import PropTypes from 'prop-types';
import unorm from 'unorm';
import { PieChart, Pie, Cell, Tooltip } from 'recharts';
import colors from '../../common/arrayColors';

// function performed: make a cross with the colors of the setting
const color = (arr, type, name, index) => {
  try {
    let str = type[name];
    str = unorm.nfd(str).replace(/[\u0300-\u036f]/g, '');
    str = str.toLowerCase();
    const obj = arr.find(o => o.key === str);
    return obj.color;
  } catch (err) {
    return colors[index];
  }
};

// function performed to translate the elements according to the configuration of the setting
const translate = obj => {
  const newArr = [];
  let str = '';
  let objs;
  let newObj;
  // traversal which we perform in the replace and add the content to a new array
  obj.data.forEach(item => {
    newObj = {};
    str = unorm.nfd(item[obj.name]).replace(/[\u0300-\u036f]/g, '');
    str = str.toLowerCase();
    objs = obj.setting.find(o => o.key === str);
    newObj[obj.name] = objs[`${obj.language}Name`];
    newObj[obj.key] = item[obj.key];
    newArr.push(newObj);
  });
  return newArr;
};

const validate = (data, value) => {
  const val = data.length;
  let sum = 0;
  data.forEach(item => {
    if (item[value] === 0) {
      sum += 1;
    }
  });
  return sum !== val;
};

const PieComponent = props => {
  let data;
  // validation if we want to do a translate with configuration of the setting
  if (props.translate) {
    data = translate({
      data: props.data,
      setting: props.colors,
      language: props.language,
      key: props.value,
      name: props.name
    });
  } else {
    data = props.data;
  }
  const vacio = {};
  vacio[props.value] = 100;
  vacio[props.name] = '-';
  return (
    <PieChart width={props.width} height={props.height}>
      <Pie
        isAnimationActive={props.animation}
        data={validate(data, props.value) ? data : [vacio]}
        dataKey={props.value}
        nameKey={props.name}
        labelLine={false}
        outerRadius={props.size}
        fill="#f0f0f0"
      >
        {props.data.map((entry, index) => (
          <Cell
            key={props.name}
            fill={
              validate(data, props.value)
                ? color(props.colors, entry, props.name, index)
                : '#DEDEDE'
            }
          />
        ))}
      </Pie>
      {validate(data, props.value) && <Tooltip />}
    </PieChart>
  );
};

PieComponent.propTypes = {
  animation: PropTypes.bool.isRequired,
  translate: PropTypes.bool.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  size: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.number, PropTypes.object])
    .isRequired,
  colors: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired
};

export default PieComponent;



// WEBPACK FOOTER //
// ./source/client/components/common/new_graph/pie.jsx